module.exports = __webpack_public_path__ + "static/media/banner-tenant.ee2a2504.jpg";